export const FENNEC_COLORS = {
  green: '#006233',
  white: '#FFFFFF',
  red: '#D21034',
  darkGreen: '#004225',
  navy: '#0f3460',
  gold: '#d4af37',
};

/** CSS variable names — values overridden in fennec-tokens.css when body.fennec-active */
export const FENNEC_CSS_VARS = {
  brand: '--color-brand',
  brandHover: '--color-brand-hover',
  primary: '--bs-primary',
  accent: '--color-accent',
  bg: '--color-bg',
  bgCard: '--color-bg-card',
  border: '--color-border',
  fennecGreen: '--fennec-green',
};

export const FENNEC_CONTEXTS = {
  ALGERIA_LIVE: 'ALGERIA_LIVE',
  ALGERIA_MATCHDAY: 'ALGERIA_MATCHDAY',
  ALGERIA_POST_0_6H: 'ALGERIA_POST_0_6H',
  ALGERIA_POST_6_24H: 'ALGERIA_POST_6_24H',
  OTHER_MATCH_LIVE: 'OTHER_MATCH_LIVE',
  MATCHDAY_NO_ALGERIA: 'MATCHDAY_NO_ALGERIA',
  NO_MATCH: 'NO_MATCH',
};

export const FENNEC_WIDGET_TYPES = {
  COUNTDOWN_MATCH: 'COUNTDOWN_MATCH',
  LIVE_MATCH: 'LIVE_MATCH',
  RESULT_MATCH: 'RESULT_MATCH',
  UPCOMING_MATCHES: 'UPCOMING_MATCHES',
  YESTERDAY_MATCHES: 'YESTERDAY_MATCHES',
  GROUP_STANDINGS_ALGERIA: 'GROUP_STANDINGS_ALGERIA',
  GROUP_STANDINGS_OTHER: 'GROUP_STANDINGS_OTHER',
  TOP_SCORERS: 'TOP_SCORERS',
  TOP_ASSISTERS: 'TOP_ASSISTERS',
  SUPPORTER_MISSION: 'SUPPORTER_MISSION',
};

export const FENNEC_EVENTS = {
  TOGGLE_ON: 'TOGGLE_ON',
  TOGGLE_OFF: 'TOGGLE_OFF',
  WIDGET_IMPRESSION: 'WIDGET_IMPRESSION',
  WIDGET_CLICK: 'WIDGET_CLICK',
  POST_IMPRESSION: 'POST_IMPRESSION',
  POST_LIKE: 'POST_LIKE',
  POST_COMMENT: 'POST_COMMENT',
  POST_SHARE: 'POST_SHARE',
};

export const FENNEC_REFRESH_INTERVAL = 60000;
/** Pinned live widget poll while WebSocket alignment is pending (see useFennecWebSocket.js). */
export const FENNEC_PINNED_POLL_INTERVAL = 45000;
export const FENNEC_FEED_PAGE_SIZE = 20;

export const FENNEC_STORAGE_KEY = 'fennec_enabled';
export const FENNEC_SESSION_KEY = 'fennec_session_id';

/** Auth routes — platform Fennec tokens / branding are not applied */
export const FENNEC_AUTH_ROUTES = new Set([
  'auth1.sign-in1',
  'auth1.sign-up1',
  'auth1.recoverpassword1',
  'auth1.verify-account',
  'auth1.delete-user',
  'auth1.contact-us',
]);
